import { Button, Modal, Text } from '@kula-ai/components';
import { Flex } from '@chakra-ui/react';

interface AnonymizeModalProps {
  open: boolean;
  // Second pass after err_confirm_required_active_applications
  requiresActiveConfirm: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export const AnonymizeModal = ({
  open,
  requiresActiveConfirm,
  onClose,
  onConfirm,
  isSubmitting,
}: AnonymizeModalProps) => (
  <Modal
    open={open}
    onOpenChange={(v: boolean) => !v && onClose()}
    title={
      requiresActiveConfirm
        ? 'Candidate has active applications'
        : 'Anonymize candidate?'
    }
    footer={
      <Flex justify="flex-end" gap="8px" w="100%">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} isLoading={isSubmitting}>
          {requiresActiveConfirm ? 'Anonymize anyway' : 'Anonymize'}
        </Button>
      </Flex>
    }
  >
    <Text>
      {requiresActiveConfirm
        ? 'This candidate is still active on one or more jobs. Anonymizing will permanently scrub their personal data everywhere, including active applications. This cannot be undone.'
        : 'This permanently removes all personal data for this candidate — profile details, resumes, messages, and interview records. This cannot be undone.'}
    </Text>
  </Modal>
);
